"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _majorType = require("@/api/project/majorType");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "名称",
        prop: "majorName",
        isShow: true,
        width: "200"
      }, {
        name: "编码",
        prop: "majorCode",
        isShow: true,
        width: "200"
      }, {
        name: "所属省份",
        prop: "provinceName",
        isShow: true,
        width: "200"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      options: []
    };
  },
  methods: {
    // 添加专业类
    addChild: function addChild(e) {
      this.$router.push({
        path: "/object/majorSmallTypeList",
        query: {
          id: e.id
        }
      });
    },
    // 获取专业大类列表
    getMajorList: function getMajorList() {
      var _this = this;
      (0, _majorType.majorList)({
        parentId: "0",
        nameOrCode: this.queryValue,
        provinceId: "",
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    // 编辑
    edit: function edit(e) {
      console.log("ppp", e);
      this.$router.push({
        path: "/object/majorObject-edit",
        query: e
      });
    },
    // 新增
    save: function save() {
      this.$router.push("/object/majorObject-add");
    },
    // 模糊搜索
    search: function search(e) {
      this.queryValue = e.queryValue;
      this.getMajorList();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this2 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this2.checkBoxs.push(item.id);
      });
    },
    deleteById: function deleteById(row) {
      var _this3 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _majorType.majorDel)(id).then(function () {
          _this3.getMajorList();
          _this3.$message.success("操作成功。");
        });
      }).catch(function () {
        _this3.$message.info("取消删除。");
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getMajorList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageNumber = 1;
      this.page.pageSize = e;
      this.getMajorList();
    }
  },
  created: function created() {
    this.getMajorList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};